<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Add User Working days</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

   
    

 
        <div class="form-group">
            <label style="margin-left: 315px;">Select Month</label>

            <input type="month" id="test" name="test"  class="form-control form-control-lg size" [(ngModel)]="Date"  (change)="MonthSelected()">
        
  
        
        <!---------------------------------------------------------->
        </div>

        <mat-form-field *ngIf="calenderShown">
            <ngx-multiple-dates [matDatepicker]="picker" placeholder="Select Dates" name="excludedDates"
                                [(ngModel)]="model" [min]="minDate" [max]="maxDate">
            </ngx-multiple-dates>
            <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

        <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick(); notification();">Submit</button>

    </div>
    </div>

